export default __webpack_public_path__ + "static/web-0ef9782c4340e873a15d2ccccf30223c.jpg";